import React, { useState, Component, useRef, useEffect } from "react";
import useStyles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import { Redirect } from "react-router-dom";
import { Icon, Link, Button } from "@material-ui/core";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputBase from "@material-ui/core/InputBase";

//Icons

//files
import noImage from "../../assets/images/Product Images/noImage.png";
import productImage2 from "../../assets/images/Product Images/hummingbird-printed-t-shirt (1).jpg";
import api from "../../Axios/api";

// MUI Components
import { Grid, Typography } from "@material-ui/core";
import ProductCard from "../../Components/Product-Card/ProductCard";

export default function StoreProducts(props) {
  const BootstrapInput = withStyles((theme) => ({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }))(InputBase);

  const classes = useStyles();

  const [sort, setSort] = React.useState([
    "Best Matched",
    "Price (Low to High)",
    "Price (High to Low)",
  ]);
  const [storeProducts, setStoreProducts] = useState([]);
  const [selectedSort, setSelectedSort] = useState(sort[0]);
  const storeId = props.storeId;
  const handleChangeSorting = (event) => {
    setSelectedSort(event.target.value);
    if (event.target.value === "Price (Low to High)" || "Best Matched") {
      storeProducts.sort((a, b) => a.salePrice - b.salePrice);
      setStoreProducts(storeProducts);
    }

    if (event.target.value === "Price (High to Low)") {
      storeProducts.sort((a, b) => b.salePrice - a.salePrice);
      setStoreProducts(storeProducts);
    }
  };

  useEffect(() => {
    api
      .get(`/buyer/products/store/${storeId}`, {}, { Headers: {} })
      .then((res) => {
        setStoreProducts(res.data.data.products);
      })
      .catch((error) =>
        console.log("error in getting data of store products", error)
      );
  }, [storeId]);

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <div className={classes.mainAboutusContainer}>
        {/* Main Grid containing all items */}
        <Grid container>
          {/* Products Grid */}
          <Grid lg={12} md={12} sm={12} className={classes.mainProductsGrid}>
            <div className={classes.ProductsHeadingBox}>
              <Typography variant="h4">
                {props.storeName ? props.storeName : "Store Products"}
              </Typography>
              {/* Sorting And results text box */}
              <div className={classes.resultsAndSortBox}>
                <Typography variant="p">
                  Showing {storeProducts.length} products of{" "}
                  {props.storeName ? props.storeName : "Store"}.
                </Typography>
                <div style={{ display: "flex" }}>
                  <Typography
                    variant="p"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    Sort By:
                  </Typography>
                  <FormControl className={classes.formSorting}>
                    {/* <InputLabel htmlFor="demo-customized-select-native">
                    Sort By
                  </InputLabel> */}
                    <Select
                      native
                      label="Sort"
                      id="demo-customized-select-native"
                      value={selectedSort}
                      label
                      onChange={handleChangeSorting}
                      input={<BootstrapInput />}
                    >
                      {/* <option aria-label="None" value="Best Match" /> */}
                      {sort.map((item, index) => {
                        return (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>

            {/* All Products Box */}
            <Grid container className={classes.productsMainGrid}>
              {storeProducts
                ? storeProducts.map((item) =>
                    React.cloneElement(
                      <ProductCard
                        _id={item._id}
                        image={
                          Array.isArray(item.images)
                            ? item.images.length > 0
                              ? item.images[0]
                              : noImage
                            : item.images
                            ? item.images
                            : noImage
                        }
                        title={item.name}
                        cutPrice={item.discountPrice ? item.salePrice : null}
                        price={
                          item.discountPrice
                            ? item.discountPrice
                            : item.salePrice
                        }
                        category={item.category}
                        isNew={item.state === "new" ? true : false}
                        rating={item.avgRating}
                        discountPercentage={
                          item.discountPercentage
                            ? item.discountPercentage
                            : ""
                        }
                        storeName={item.storeName}
                        totalRatingStars={item.totalRatingStars}
                        brand={item.vendorCompanyName}
                        shippingCost={item.shippingCost}
                        stockAvailable={item.stockAvailable}
                        _id={item._id}
                      />,
                      {
                        key: { item },
                      }
                    )
                  )
                : null}
            </Grid>
            <Button
              variant="outlined"
              style={{
                display: "flex",
                left: 10,
                marginTop: 10,
                marginRight: "auto",
                visibility: storeProducts.length > 20 ? "block" : "hidden",
              }}
            >
              Load More {">>"}
            </Button>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
